exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body > app > .main-container {\n  overflow: auto;\n  height: 100%; }\n\nbody > app > .main-container > main {\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 100%; }\n\nbody > app > .main-container > main > app > div > main {\n  width: 100%; }\n\n.pt .datagrid-select {\n  display: flex;\n  align-items: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/publisher/src/publisher-ui/publisher.scss
// module id = GLg4
// module chunks = 0